export enum ModalRoleEnum {
  CONFIRM = 'CONFIRM',
  CANCEL = 'CANCEL'
}

export enum ApplicantModalEnum {

}
export enum ToastColorEnum {
  ERROR = 'danger',
  SUCCESS = 'success',
  WARNING = 'warning',
}
